<template>
    <div id="customerScopeRate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="custScopeRateHeader" v-if="$route.params.id > 0">Update Rental Rate</span>
                    <span class="page-title" id="custScopeRateHeader" v-else>Add Rental Rate</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleList">
                        <i class="fp-back"> </i>    Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-scope-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="customerScopeRateForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="customer_id">Agreement No.:</label>
                                        <v-select v-model="agreementId" name="agreement_no" :disabled="disableAgreement"
                                                label="text" :filterable="false" :options="rentalAgreementArr"
                                                @search="onSearchAgreements"
                                                placeholder="Search Agreement No." class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Agreement...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ agreementError }}</div>
                                    </div>
                                    <div class="col-sm-5">
                                        <label for="truckType" class="control-label require">Truck Type :</label>
                                        <v-select v-model="truckType" label="text" name="truckType" id="truckType"
                                            :options="truckSelect" class="close-remove" placeholder='Select Truck Type' :disabled="disableTruckType">
                                        </v-select>
                                        <div class="field-error">{{ truckTypeError }}</div>
                                    </div>
                                </div>
                                <!-- <div class="table-responsive-sm mt-3">
                                    <table aria-describedby="table" id="scope_Rate_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:300px">Section</th>
                                                <th scope="col" class="require" style="width:200px">Rate Type</th>
                                                <th scope="col" class="require text-right">Rate</th>
                                                <th scope="col" class="">Discount</th>
                                                <th scope="col" class="require text-right">Total</th>
                                                <th scope="col" class="" style="width:150px">Discount Reason</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    <input type="hidden" v-model="row.id">
                                                    <v-select class="custom-ci-auto-search contract-data close-remove" v-model="row.sectionRateId" placeholder="Select Section" label="text" :options="sectionArr"></v-select>
                                                    <div class="field-error">{{ row.sectionRateError }}</div>
                                                </td>
                                                <td>
                                                    <v-select v-model="row.rateType"
                                                        label="text" :options="rateTypeArr" placeholder="Select Rate Type" class="close-remove"></v-select>
                                                    <div class="field-error">{{ row.rateTypeError }}</div>
                                                </td>
                                                <td>
                                                    <input v-model="row.rate" type="rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="rate" name="rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control text-right" v-model="row.discount" @input="calculateDiscount($event,index,'discount')" id="discount_percent" @keypress="isNumberCheck($event)" placeholder="Discount Percent" name="discount_percent" aria-describedby="basic-addon3">
                                                        <v-select v-model="row.discount_type" label="text" :options="disTypeArr" placeholder="Select Type" @input="calculateDiscount($event,index,'discount')" class="close-remove input-group-append"></v-select>
                                                      
                                                    </div>
                                                </td>
                                                <td>
                                                    <input :disabled="true" v-model="row.total" type="rate" class="form-control text-right" placeholder="Total" id="total" name="total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td>
                                                    <v-select v-model="row.reason" label="text" :options="reasonArr" placeholder="Select Reason" class="close-remove"></v-select>
                                                    <div class="field-error">{{ row.reason_error_msg }}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click="removeRow(index,row.id);"> <i class="fp-remove"></i>
                                                            </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> -->

                                <div class="table-responsive-sm mt-3">
                                    <table aria-describedby="table" id="scope_Rate_table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="require" style="width:200px">Section</th>
                                                <th scope="col" class="require text-right" style="width:100px">Day</th>
                                                <th scope="col" class="require text-right" style="width:100px">Total</th>
                                                 <th scope="col" class="require text-right" style="width:100px">Week</th>
                                                <th scope="col" class="require text-right" style="width:100px">Total</th>
                                                 <th scope="col" class="require text-right" style="width:100px">Month</th>
                                                <th scope="col" class="require text-right" style="width:100px">Total</th>
                                                <th scope="col" class="">Discount</th>
                                                <!-- <th scope="col" class="require text-right">Total</th> -->
                                                <th scope="col" class="" style="width:150px">Discount Reason</th>
                                                <th scope="col"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr  v-for="(row, index) in rows" :key="index">
                                                <td>
                                                    <input type="hidden" v-model="row.id">
                                                    <v-select class="custom-ci-auto-search contract-data close-remove" v-model="row.sectionRateId" placeholder="Select Section" label="text" :options="sectionArr" @input="selectSection(row.sectionRateId,index)"></v-select>
                                                    <div class="field-error">{{ row.sectionRateError }}</div>
                                                </td>
                                                <!-- <td>
                                                    <v-select v-model="row.rateType"
                                                        label="text" :options="rateTypeArr" placeholder="Select Rate Type" class="close-remove"></v-select>
                                                    <div class="field-error">{{ row.rateTypeError }}</div>
                                                </td> -->
                                                <td v-if="row.type == 'mile'">
                                                    <input v-model="row.mile_rate" type="mile_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="mile_rate" name="mile_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-else-if="row.type == 'hour'">
                                                    <input v-model="row.hour_rate" type="hour_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="hour_rate" name="hour_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-else>
                                                    <input v-model="row.day_rate" type="day_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="day_rate" name="day_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-if="row.type == 'mile'">
                                                    <input :disabled="true" v-model="row.mile_total" type="mile_total" class="form-control text-right" placeholder="Total" id="mile_total" name="mile_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td v-else-if="row.type == 'hour'">
                                                    <input :disabled="true" v-model="row.hour_total" type="hour_total" class="form-control text-right" placeholder="Total" id="hour_total" name="hour_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td v-else>
                                                    <input :disabled="true" v-model="row.day_total" type="day_total" class="form-control text-right" placeholder="Total" id="day_total" name="day_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td v-if="row.type == 'mile'">
                                                    <input v-model="row.mile_rate" type="mile_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="mile_rate" name="mile_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-else-if="row.type == 'hour'">
                                                    <input v-model="row.hour_rate" type="hour_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="hour_rate" name="hour_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-else>
                                                    <input v-model="row.week_rate" type="week_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="rate" name="rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                 <td v-if="row.type == 'mile'">
                                                    <input :disabled="true" v-model="row.mile_total" type="mile_total" class="form-control text-right" placeholder="Total" id="mile_total" name="mile_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td v-else-if="row.type == 'hour'">
                                                    <input :disabled="true" v-model="row.hour_total" type="hour_total" class="form-control text-right" placeholder="Total" id="hour_total" name="hour_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td v-else>
                                                    <input :disabled="true" v-model="row.week_total" type="week_total" class="form-control text-right" placeholder="Total" id="week_total" name="week_total" @keypress="isNumberCheck($event)">
                                                </td>

                                                <td v-if="row.type == 'mile'">
                                                    <input v-model="row.mile_rate" type="mile_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="mile_rate" name="mile_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-else-if="row.type == 'hour'">
                                                    <input v-model="row.hour_rate" type="hour_rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="hour_rate" name="hour_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-else>
                                                    <input v-model="row.month_rate" type="rate" :disabled="rateDisable && (row.is_manual == undefined || !row.is_manual) " class="form-control text-right" placeholder="Rate" id="month_rate" name="month_rate" @input="calculateDiscount($event,index,'rate')" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ row.rateError }}</div>
                                                </td>
                                                <td v-if="row.type == 'mile'">
                                                    <input :disabled="true" v-model="row.mile_total" type="mile_total" class="form-control text-right" placeholder="Total" id="mile_total" name="mile_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td v-else-if="row.type == 'hour'">
                                                    <input :disabled="true" v-model="row.hour_total" type="hour_total" class="form-control text-right" placeholder="Total" id="hour_total" name="hour_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td v-else>
                                                    <input :disabled="true" v-model="row.month_total" type="day_total" class="form-control text-right" placeholder="Total" id="day_total" name="day_total" @keypress="isNumberCheck($event)">
                                                </td>
                                                <td>
                                                    <div class="input-group">
                                                        <input type="text" class="form-control text-right" v-model="row.discount" @input="calculateDiscount($event,index,'discount')" id="discount_percent" @keypress="isNumberCheck($event)" placeholder="Discount Percent" name="discount_percent" aria-describedby="basic-addon3">
                                                        <v-select v-model="row.discount_type" label="text" :options="disTypeArr" placeholder="Select Type" @input="calculateDiscount($event,index,'discount')" class="close-remove input-group-append"></v-select>
                                                      
                                                    </div>
                                                </td>
                                                <!-- <td>
                                                    <input :disabled="true" v-model="row.total" type="rate" class="form-control text-right" placeholder="Total" id="total" name="total" @keypress="isNumberCheck($event)">
                                                </td> -->
                                                <td>
                                                    <v-select v-model="row.reason" label="text" :options="reasonArr" placeholder="Select Reason" class="close-remove"></v-select>
                                                    <div class="field-error">{{ row.reason_error_msg }}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click="removeRow(index,row);"> <i class="fp-remove"></i>
                                                            </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                        <i class="fp-add"></i> Add Rate
                                    </button>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                        <div class="field-error">{{ error_msg }}</div>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createScopeRateBtn" class="btn btn-primary" v-if="$route.params.id > 0" v-on:click.prevent="addrecord('')">
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createScopeRateBtn" class="btn btn-primary" v-if="$route.params.id > 0 && $route.query.from != undefined && $route.query.from =='agreement' && ctCode != 'RM' && ctCode != 'RI'" v-on:click.prevent="onRequestApproval()">
                                    <i class="fp-reload"> </i>  Update And Request Approval
                                    </button>
                                    <button type="submit" id="createScopeRateBtn" class="btn btn-primary" v-if="$route.params.id == undefined" v-on:click.prevent="addrecord('')">
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueScopeRateBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="addrecord(flag='Save and Continue')">
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelScopeRateBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                        <div class="modal fade invoice-modal update-reading-modal" id="expiryDateModal" ref="expiryDateModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Expiry Date</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm telematics-reading-form">
                                            <div class="form-row row-cols-md-2 row-cols-1">
                                                <!-- <input class="form-control" id="unitNum" type="hidden" v-model="id"> -->
                                                <div class="col form-group">
                                                    <label class="control-label require" for="name">Approval Until</label>
                                                    <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="expiry_date" v-model="expiry_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                                    <span class="field-error">{{expirydate_error_msg}}</span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer btm-action-btn-fl">
                                        <button class="btn btn-primary" id="dateButton" v-on:click="addrecord('approval')"> <i class="fp-reload"> </i> Update</button>
                                        <button type="button" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
import EventBus from ".././event-bus";
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
export default {
    name: "customerScopeRate",
    
    metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Customer Scope Rate | " +process.env.COPYRIGHT_NAME : "Create Customer Scope Rate | " +process.env.COPYRIGHT_NAME
        }
    },
    mixins:[commonMixins],
    data: () => ({
        recordId:0,
        agreementId:"",
        disableAgreement:false,
        truckType: null,
        truckSelect: [{
            value: "", text: "Select Truck"
        }],
        sectionRateId: null,
        sectionArr: [],
        rate: "",
        query: "",
        title: "Add",
        results: [],
        optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: true,
        },
        expiry_date:'',
        type_rate: "day",
        type_id: "",
        rental_rate_id: 0,
        cancelbtn: false,
        formerrors: [],
        msgClass: "",
        button_text: "Add",
        cantAccessPage:"",
        permissions:[],
        error_msg:"",
        agreementError: "",
        truckTypeError: "",
        rateerrors: "",
        ratetypeerrors: "",
        sectionerrors: "",
        loading:false,
        rentalAgreementArr:[],
        disableTruckType:false,
        rows:[{
            day_id:0,
            week_id:0,
            month_id:0,
            // rateType: "",
            sectionRateId: "",
            day_rate:"",
            week_rate:"",
            month_rate:"",
            // mile_rate:"",
            // hour_rate:"",
            sectionRateError:"",
            // rateTypeError:"",
            rateError:"",
            discount:'',
            discount_type:{text:'%',value:'%'},
            discount_error_msg:'',
            day_total:'',
            week_total:'',
            month_total:'',
            reason:'',
            reason_error_msg:'',
            is_manual:true
        }],
        reasonArr:[{text:'Breakdown',value:'BRKDWN'},{text:'Customer Accomodation',value:'ACCOM'}],
        expirydate_error_msg:'',
        agreementEndDate:'',
        ctCode:'',
        rateDisable:false,
        disTypeArr:[{text:'%',value:'%'},{text:'$',value:'$'}]

    }),

    watch:{
        agreementId: function(agreemenet) {

            var path = window.location.pathname;
            var segments = path.split("/");

            //execute if create scope rate only
            if (!segments[3]) {
                //if selected agreement
                if ( agreemenet != null && agreemenet != "" && agreemenet.value != "" ) {
                    this.truckType = { value: agreemenet.vtId, text: agreemenet.vtCode + " | " + agreemenet.vtName};
                    //disable vehicle type drop down
                    // $("#truckType").addClass("disable-field");
                    this.disableTruckType = true;
                    //load rates
                    this.loadCustomerScopeRate(0,agreemenet.value,agreemenet.vtId);

                } else {
                    this.truckType = null;
                    //disable vehicle type drop down
                    // $("#truckType").addClass("disable-field");
                    this.disableTruckType = false;
                }
            }else{
                if ( agreemenet != null && agreemenet != "" && agreemenet.value != "" ) {
                    if (agreemenet.end_date){
                        this.agreementEndDate = agreemenet.end_date;
                    }
                    if (agreemenet.con_code){
                        this.ctCode = agreemenet.con_code;

                        // if (this.ctCode == 'RM' || this.ctCode == 'RI'){
                        //     this.rateDisable = true;
                        // }
                        // if (this.ctCode == 'RI'){
                        //     this.rateDisable = true;
                        // }
                    }
                }
            }

        },
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if (self.$route.query.from != undefined && self.$route.query.from == 'agreement'){
                    if (permissions.name == 'add_rental_agreement') {
                        self.cantAccessPage = true;
                    }
                    if (permissions.name == 'can_approve_rate') {
                        setTimeout(function(){
                            self.rateDisable = false;
                        },1000);
                    }
                    
                }else{
                    if(permissions.name == 'add_rate' ) {
                        self.cantAccessPage = true;
                    }
                }
            });
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        },
        sectionRateId: function(section) {

            var sectionText = section.text;
            if ( sectionText.indexOf("Fixed") !== -1 ) {
                this.rateTypeArr.splice(3,1);
            } else {
                if ( !this.rateTypeArr[3]) {
                    this.rateTypeArr.push({value:'mile',text:'Mile'});
                }
            }
        },
    },

    mounted: function() {

        var self = this;

        self.getTruckType();
        self.getPermissions();

        setTimeout(function () {

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.recordId = segments[3];
                self.loadCustomerScopeRate(self.recordId,0,0);
            }
        }, 100);

    },

    methods: {

        addRow: function () {

            var self = this;
            var index = self.rows.length - 1;

            self.rows[index].sectionRateError = "";
            self.rows[index].rateTypeError = "";
            self.rows[index].rateError = "";
            self.rows[index].reason_error_msg = "";

            var reasonError = '';
            if(self.rows[index].discount != '' && self.rows[index].discount > 0 && (self.rows[index].reason == null || self.rows[index].reason == '' )){
                reasonError = 'true';
            }

            if ( self.rows[index].sectionRateId != null && self.rows[index].sectionRateId.value != ""
                    && ((self.rows[index].day_rate != null && self.rows[index].day_rate) || (self.rows[index].week_rate != null && self.rows[index].week_rate) || (self.rows[index].month_rate != null && self.rows[index].month_rate) || (self.rows[index].mile_rate != null && self.rows[index].mile_rate) || (self.rows[index].hour_rate != null && self.rows[index].hour_rate)) /*self.rows[index].rate != ""*/
                    && reasonError == '' ) {

                self.rows.push({
                    day_id:0,
                    week_id:0,
                    month_id:0,
                    // rateType: "",
                    sectionRateId: "",
                    day_rate:"",
                    week_rate:"",
                    month_rate:"",
                    // mile_rate:"",
                    // hour_rate:"",
                    sectionRateError:"",
                    // rateTypeError:"",
                    rateError:"",
                    discount:'',
                    discount_type:{text:'%',value:'%'},
                    discount_error_msg:'',
                    day_total:'',
                    week_total:'',
                    month_total:'',
                    reason:'',
                    reason_error_msg:'',
                    is_manual:true
                });

            } else {
                if ((self.rows[index].day_rate == null || !self.rows[index].day_rate) && (self.rows[index].week_rate == null || !self.rows[index].week_rate) && (self.rows[index].month_rate == null || !self.rows[index].month_rate) && (self.rows[index].mile_rate == null || !self.rows[index].mile_rate) && (self.rows[index].hour_rate == null || !self.rows[index].hour_rate)) {
                    self.rows[index].rateError = "Rate is required.";
                }
                if (self.rows[index].sectionRateId == null || !self.rows[index].sectionRateId.value ) {
                    self.rows[index].sectionRateError = "Section rate is required.";
                }
                // if (self.rows[index].rateType == null || !self.rows[index].rateType.value ) {
                //     self.rows[index].rateTypeError = "Section rate type is required.";
                // }

                if (self.rows[index].discount != null && self.rows[index].discount > 0 && (self.rows[index].reason == null || self.rows[index].reason == '' )) {
                    self.rows[index].reason_error_msg = "Discount Reason required.";
                }
            }


        },
        // calculateDiscount:function(evt,index,flag){
        //     var self = this;
        //     console.log(self.rows[index].discount);
        //     if (self.rows[index].discount && self.rows[index].rate){

        //         if (self.rows[index].discount_type != undefined && self.rows[index].discount_type != null && self.rows[index].discount_type.value == '$'){
        //             var total = self.rows[index].rate - self.rows[index].discount;
        //         }else{
        //             var total = self.rows[index].rate - (self.rows[index].discount * self.rows[index].rate) / 100;

        //         }

        //         self.rows[index].total = total.toFixed(2);

        //     }else{
        //         self.rows[index].total = self.rows[index].rate;
        //     }

        //     if (flag == 'discount'){
        //         if (self.rows[index].discount > 0){
        //             // self.rows[index].reason = 'ACCOM';
        //             self.rows[index].reason = {text:'Customer Accomodation',value:'ACCOM'}
        //         }else{
        //             self.rows[index].reason = '';
        //         }
        //     }
        // },

         calculateDiscount:function(evt,index,flag){
            var self = this;
            console.log(self.rows[index].discount);
            if (self.rows[index].discount){

                if (self.rows[index].discount_type != undefined && self.rows[index].discount_type != null && self.rows[index].discount_type.value == '$'){

                    if (self.rows[index].day_rate != undefined){
                        var day_total = self.rows[index].day_rate - self.rows[index].discount;
                        self.rows[index].day_total = day_total.toFixed(2);

                    }
                    if (self.rows[index].week_rate != undefined){
                        var week_total = self.rows[index].week_rate - self.rows[index].discount;
                        self.rows[index].week_total = week_total.toFixed(2);

                    }
                    if (self.rows[index].month_rate != undefined){
                        var month_total = self.rows[index].month_rate - self.rows[index].discount;
                        self.rows[index].month_total = month_total.toFixed(2);

                    }
                    if (self.rows[index].mile_rate != undefined){
                        var mile_total = self.rows[index].mile_rate - self.rows[index].discount;
                        self.rows[index].mile_total = mile_total.toFixed(2);
                    }
                    if (self.rows[index].hour_rate != undefined){
                        var hour_total = self.rows[index].hour_rate - self.rows[index].discount;
                        self.rows[index].hour_total = hour_total.toFixed(2);
                    }
                }else{
                    // var total = self.rows[index].rate - (self.rows[index].discount * self.rows[index].rate) / 100;

                    if (self.rows[index].day_rate != undefined){
                        var day_total = self.rows[index].day_rate - (self.rows[index].discount * self.rows[index].day_rate) / 100;
                        self.rows[index].day_total = day_total.toFixed(2);
                    }
                    if (self.rows[index].week_rate != undefined){
                        var week_total = self.rows[index].week_rate - (self.rows[index].discount * self.rows[index].week_rate) / 100;
                        self.rows[index].week_total = week_total.toFixed(2);
                    }
                    if (self.rows[index].month_rate != undefined){
                        var month_total = self.rows[index].month_rate - (self.rows[index].discount * self.rows[index].month_rate) / 100;
                        self.rows[index].month_total = month_total.toFixed(2);
                    }
                    if (self.rows[index].mile_rate != undefined){
                        var mile_total = self.rows[index].mile_rate - (self.rows[index].discount * self.rows[index].mile_rate) / 100;
                        self.rows[index].mile_total = mile_total.toFixed(2);
                    }
                    if (self.rows[index].hour_rate != undefined){
                        var hour_total = self.rows[index].hour_rate - (self.rows[index].discount * self.rows[index].hour_rate) / 100;
                        self.rows[index].hour_total = hour_total.toFixed(2);
                    }
                }
                // if (self.rows[index].discount_type != undefined && self.rows[index].discount_type != null && self.rows[index].discount_type.value == '$'){
                //     var total = self.rows[index].rate - self.rows[index].discount;
                // }else{
                //     var total = self.rows[index].rate - (self.rows[index].discount * self.rows[index].rate) / 100;

                // }
                // if (self.rows[index].discount_type != undefined && self.rows[index].discount_type != null && self.rows[index].discount_type.value == '$'){
                //     var total = self.rows[index].rate - self.rows[index].discount;
                // }else{
                //     var total = self.rows[index].rate - (self.rows[index].discount * self.rows[index].rate) / 100;

                // }
            }
            // else{
            //     self.rows[index].total = self.rows[index].rate;
            // }

            if (flag == 'discount'){
                if (self.rows[index].discount > 0){
                    // self.rows[index].reason = 'ACCOM';
                    self.rows[index].reason = {text:'Customer Accomodation',value:'ACCOM'}
                }else{
                    self.rows[index].reason = '';
                }
            }
        },

        removeRow: function (index,rowId) {

            var self = this;

            if ((rowId.day_id == undefined || rowId.day_id == 0) && (rowId.week_id == undefined || rowId.week_id == 0) && (rowId.month_id == undefined || rowId.month_id == 0) && (rowId.mile_id == undefined || rowId.mile_id == 0) && (rowId.hour_id == undefined || rowId.hour_id == 0) ) {
                self.rows.splice(index, 1);

            } else {

                if ( confirm('Are you sure that you want to delete this rate? ')) {
                    var agId = 0;
                    if (self.agreementId && self.agreementId.value != undefined){
                        agId = self.agreementId.value;
                    }
                    $.ajax({
                        url: process.env.ROOT_API + "/scoperate/delete",
                        type: "POST",
                        data: {id: rowId,agId:agId},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            if (data.status == "success") {
                                self.rows.splice(index, 1);
                            }

                        },
                        error: function (jqXHR, exception) {
                            self.generateStatusCodeMessage(jqXHR,true,'scope-rate-row-delete')
                        },
                    });
                }
            }

        },

        onSearchAgreements(search, loading) {
            var self = this;
            if (search.length > 2) {
                loading(true);
                self.searchField(loading, search, 'rental_agreement');
            }
        },

        BackVehicleList() {
            var self = this;

            if (self.$route.query.from && self.$route.query.from == 'agreement'){

                self.$router.push("/rentalagreement/view/"+self.agreementId.value+"?viewTab=rental");

            } else{

                self.$router.push("/scoperate/list");

            }

        },
        onRequestApproval(){
            var self = this;
            self.expiry_date = '';
            $("#expiryDateModal").modal('show');
        },

        addrecord(flag ='') {

            var self = this;

            self.agreementError =  "";
            self.truckTypeError = "";
            self.expirydate_error_msg = '';

            var error = false;

            // if ( self.agreementId == null || !self.agreementId.value ) {
            //     self.agreementError = "Agreement No. required";
            //     error = true;
            // }
            var from = '';
            if (self.$route.query.from != undefined && self.$route.query.from == 'agreement'){
                from = self.$route.query.from;
            }

            if ( self.truckType == null || !self.truckType.value ) {
                self.truckTypeError = "TruckType required.";
                error = true;
            }
            if (flag == 'approval'){
                if ( self.expiry_date == null || self.expiry_date == '' ) {
                    self.expirydate_error_msg = "Expiry Date Required.";
                    error = true;
                }

                if (self.agreementEndDate != '' && self.expiry_date != '' && new Date(self.expiry_date) < new Date(self.agreementEndDate)){
                    self.expirydate_error_msg = "Expiry date should not be less than agreement end date.";
                    error = true;
                }
            }

            for ( var i = 0; i < self.rows.length; i++ ) {
                // console.log(self.rows[i]);
                self.rows[i].sectionRateError = "";
                self.rows[i].rateTypeError = "";
                self.rows[i].rateError = "";
                self.rows[i].discount_error_msg = "";
                self.rows[i].reason_error_msg = "";
                var tempError = 0;

                if ((self.rows[i].day_rate == null || !self.rows[i].day_rate) && (self.rows[i].week_rate == null || !self.rows[i].week_rate) && (self.rows[i].month_rate == null || !self.rows[i].month_rate) && (self.rows[i].mile_rate == null || !self.rows[i].mile_rate) && (self.rows[i].hour_rate == null || !self.rows[i].hour_rate)) {
                // if ( self.rows[i].rate == null || self.rows[i].rate == 0 || !self.rows[i].rate ) {
                    self.rows[i].rateError = "Rate is required.";
                    error = true;
                    tempError = 1;
                }

                if ( self.rows[i].sectionRateId == null || !self.rows[i].sectionRateId.value ) {
                    self.rows[i].sectionRateError = "Section is required.";
                    error = true;
                    tempError = 1;
                }

                // if ( self.rows[i].rateType == null || !self.rows[i].rateType.value ) {
                //     self.rows[i].rateTypeError = "Rate type is required.";
                //     error = true;
                //     tempError = 1;
                // }
                if (self.rows[i].discount != null && self.rows[i].discount > 0 && parseInt(self.rows[i].discount) > 100){
                    self.rows[i].discount_error_msg = "Must be less than 100";
                    error = true;
                    tempError = 1;
                }
                if (self.rows[i].discount != null && self.rows[i].discount > 0 && (self.rows[i].reason == null || !self.rows[i].reason.value )) {
                    self.rows[i].reason_error_msg = "Discount Reason required.";
                    error = true;
                    tempError = 1;
                }

                //for to check same rate added multiple times with same rate type
                for ( var j = 0; j < i; j++ ) {

                    if ( tempError == 0 ) {
                        if ( self.rows[i].sectionRateId.value == self.rows[j].sectionRateId.value
                                        ) {
                            self.rows[i].sectionRateError = "Same section and rate type can not be added multiple times.";
                            error = true;
                        }
                    }
                }

            }

            if ( !error ) {

                self.loading = true;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[3])
                {
                    $("#createScopeRateBtn").val("Updating ...");
                    $("#createScopeRateBtn").prop("disabled", true);
                    $("#cancelScopeRateBtn").prop("disabled",true);
                } else {
                    if (flag == "Save and Continue") {

                        $("#createAndContinueScopeRateBtn").val("Saving ...");
                        $("#createScopeRateBtn").prop("disabled", true);
                        $("#createAndContinueScopeRateBtn").prop("disabled", true);
                        $("#cancelScopeRateBtn").prop("disabled",true);

                    }else{

                        $("#createScopeRateBtn").val("Saving ...");
                        $("#createScopeRateBtn").prop("disabled", true);
                        $("#createAndContinueScopeRateBtn").prop("disabled", true);
                        $("#cancelScopeRateBtn").prop("disabled",true);
                    }

                }

                var fields = $("#customerScopeRateForm").serializeArray();
                fields.push({name: "id", value: segments[3]});
                if ( self.agreementId == null ) {
                    fields.push({name: "agreementId", value: ""});
                }else{
                    fields.push({name: "agreementId", value: self.agreementId.value});
                }
                fields.push({name: "truck_type_id", value: self.truckType.value});
                fields.push({name: "rows", value: JSON.stringify(self.rows)});
                fields.push({name: "from", value: from});

                fields.push({name: "expiry_date", value: self.expiry_date});
                fields.push({name: "flag", value: flag});

                $.ajax({
                    url: process.env.ROOT_API + "/scoperate/create",
                    type: "POST",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType:'json',
                    /*data: {
                        id: segments[3],
                        agreementId: self.agreementId.value,
                        truck_type_id: self.truckType.value,
                        rows:JSON.stringify(self.rows),
                    },*/
                    data: fields,
                    success: function(data) {
                        self.loading = false;
                        if (flag == 'approval'){
                            $("#expiryDateModal").modal('hide');
                        }
                        if (segments[3])
                        {
                            $("#createScopeRateBtn").val("Update");
                            $("#createScopeRateBtn").prop("disabled", false);
                            $("#cancelScopeRateBtn").prop("disabled",false);
                        } else {

                            if (flag == "Save and Continue") {

                                $("#createAndContinueScopeRateBtn").val("Save and Continue");
                                $("#createScopeRateBtn").prop("disabled", false);
                                $("#createAndContinueScopeRateBtn").prop("disabled", false);
                                $("#cancelScopeRateBtn").prop("disabled",false);

                            }else{

                                $("#createScopeRateBtn").val("Save");
                                $("#createScopeRateBtn").prop("disabled", false);
                                $("#createAndContinueScopeRateBtn").prop("disabled", false);
                                $("#cancelScopeRateBtn").prop("disabled",false);

                            }
                        }
                        if (data.status == "success") {

                            if (flag == "Save and Continue") {
                                self.agreementId = null;
                                self.truckType = null;
                                self.disableTruckType = false;
                                self.disableAgreement = false;
                                self.rows = [];
                                 self.rows.push({
                                    day_id:0,
                                    week_id:0,
                                    month_id:0,
                                    // rateType: "",
                                    sectionRateId: "",
                                    day_rate:"",
                                    week_rate:"",
                                    month_rate:"",
                                    // mile_rate:"",
                                    // hour_rate:"",
                                    sectionRateError:"",
                                    // rateTypeError:"",
                                    rateError:"",
                                    discount:'',
                                    discount_type:'',
                                    discount_error_msg:'',
                                    day_total:'',
                                    week_total:'',
                                    month_total:'',
                                    reason:'',
                                    reason_error_msg:'',
                                    is_manual:true
                                });


                            } else {
                                if (self.$route.query.from && self.$route.query.from == 'agreement'){

                                    self.$router.push("/rentalagreement/view/"+self.agreementId.value+"?viewTab=rental");

                                }else{

                                    self.$router.push("/scoperate/list");

                                }
                            }
                        }else if(data.status == "Invalid"){
                            self.rateerrors = data.message;
                        } else {

                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {

                                    if (data.content[i] == "The truck type id field is required.") {
                                        err += "The truck type field is required." + "<br>";
                                    } else if (data.content[i] == "The section id field is required.") {
                                        err += "The section field is required." + "<br>";
                                    } else if (data.content[i] == "The type field is required.") {
                                        err += "The rate type field is required." + "<br>";
                                    } else {
                                        err += data.content[i] + "<br>";
                                    }
                                }
                                $("#errorMsg").html(err);
                                $(".alert-warning").toggleClass("show");
                                setTimeout(function () {
                                    $(".alert-warning").removeClass("show");
                                    $(".alert-warning").addClass("hide");
                                }, 10000);
                            }
                        }

                    },
                    error: function(jqXHR, exception) {

                        self.loading = false;
                        if (segments[3]) {
                            $("#createScopeRateBtn").val("Update");
                            $("#createScopeRateBtn").prop("disabled", false);
                            $("#cancelScopeRateBtn").prop("disabled",false);
                        } else {
                            if (flag == "Save and Continue") {

                                $("#customerScopeRateForm").trigger("reset");
                                $("#createAndContinueScopeRateBtn").val("Save and Continue");
                                $("#createScopeRateBtn").prop("disabled", false);
                                $("#createAndContinueScopeRateBtn").prop("disabled", false);
                                $("#cancelScopeRateBtn").prop("disabled",false);

                            } else{

                                $("#createScopeRateBtn").val("Save");
                                $("#createScopeRateBtn").prop("disabled", false);
                                $("#createAndContinueScopeRateBtn").prop("disabled", false);
                                $("#cancelScopeRateBtn").prop("disabled",false);

                            }
                        }
                        self.generateStatusCodeMessage(jqXHR,true,'scope-rate-create')
                    }
                });

            } else {
                console.log($(".error_style").length);
                self.msgClass = "error";
                self.errorValidationFocus();
            }
        },

        getTruckType: function() {

            var self = this;
            $.ajax({
                url: process.env.ROOT_API + "/search-scoperate",
                type: "GET",
                crossDomain: true,
                data:{params:['rentalVehicleType']},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function(data) {
                    //console.log(data.content[0]["id"]);
                    if (data.status == "success") {
                        self.sectionArr = data.content.section_rates;
                        self.truckSelect = data.content.asset_type;
                    }
                },
                error: function(jqXHR, exception) {
                    self.generateStatusCodeMessage(jqXHR,true,'scope-rate-serch')
                }
            });
        },

        loadCustomerScopeRate(id,agId,vtId) {

            var self = this;
            self.loading = true;
            var from = '';
            if (self.$route.query.from != undefined){
                from = self.$route.query.from;
            }

            $.ajax({
                url: process.env.ROOT_API + "/scoperate/fetch",
                type: "POST",
                crossDomain: true,
                data:{
                    id:id,
                    agreementId:agId,
                    truckTypeId:vtId,
                    from:from
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function(data) {
                    self.loading = false;
                    if (data.status == "success") {

                        if ( agId == 0 ) {
                            self.agreementId = data.content.agreementId
                            self.truckType = data.content.truckType;
                        }
                        if ( data.content.items.length ) {
                            self.rows = data.content.items;
                        }

                        self.disableAgreement = true;
                        self.disableTruckType = true;
                        if (self.$route.query.from != undefined && self.$route.query.from == 'agreement'){
                            if (self.rows && self.rows.length){
                                for(var i = 0 ; i < self.rows.length;i++){
                                    if (self.rows[i].discount  != '' && self.rows[i].discount > 0){
                                        self.calculateDiscount('',i,'discount');
                                    }
                                }
                            }
                        }

                        // setTimeout(function(){
                        //     var span = 1;
                        //     var prevTD = "";
                        //     var prevTDVal = "";
                        //     $("#scope_Rate_table tr td:first-child").each(function() { //for each first td in every tr
                        //         var $this = $(this);
                        //         if ($this[0].innerText == prevTDVal) { // check value of previous td text
                        //             span++;
                        //             if (prevTD != "") {
                        //                 prevTD.attr("rowspan", span); // add attribute to previous td
                        //                 $this.remove(); // remove current td
                        //             }
                        //         } else {
                        //             prevTD     = $this; // store current td 
                        //             prevTDVal  = $this[0].innerText;
                        //             console.log('here');
                        //             console.log(prevTDVal);
                        //             span       = 1;
                        //         }
                        //     });
                        // },200);
                        
                    }
                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'scope-rate-custoemr-search')
                }
            });
        },

        selectSection:function(sec,ind){
            var self = this;

            if (sec.type != undefined){
                if (sec.type == 'mile'){
                    self.rows.splice(ind, 1);
                    self.rows.push({
                        mile_id:0,
                        sectionRateId: sec,
                        mile_rate:"",
                        sectionRateError:"",
                        rateError:"",
                        discount:'',
                        discount_type:'',
                        discount_error_msg:'',
                        mile_total:'',
                        reason:'',
                        reason_error_msg:'',
                        is_manual:true
                    });

                    // var obj = self.rows[ind];
                    // self.rows[ind] = self.rows[ind].map(function(obj) {
                    //     obj['mile_rate'] = obj['day_rate'];  // Assign new key
                    //     obj['mile_rate'] = obj['week_rate'];
                    //     obj['mile_rate'] = obj['month_rate'];

                    //     obj['mile_total'] = obj['day_total'];
                    //     obj['mile_total'] = obj['week_total'];
                    //     obj['mile_total'] = obj['month_total'];

                    //     obj['mile_id'] = obj['day_id'];
                    //     obj['mile_id'] = obj['week_id'];
                    //     obj['mile_id'] = obj['month_id'];

                    //     delete obj['day_rate']; // Delete old key
                    //     delete obj['week_rate'];
                    //     delete obj['month_rate'];
                    //     delete obj['day_total'];
                    //     delete obj['week_total'];
                    //     delete obj['month_total'];
                    //     delete obj['day_id'];
                    //     delete obj['week_id'];
                    //     delete obj['month_id'];
                    //     return obj;
                    // });

                }
                if (sec.type == 'hour'){
                    self.rows.splice(ind, 1);
                    self.rows.push({
                        hour_id:0,
                        sectionRateId: sec,
                        hour_rate:"",
                        sectionRateError:"",
                        rateError:"",
                        discount:'',
                        discount_type:'',
                        discount_error_msg:'',
                        hour_total:'',
                        reason:'',
                        reason_error_msg:'',
                        is_manual:true
                    });
                }
            }
        },
        // String Upper Case //
        jsUcfirst: function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        isNumberCheck: function(evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/customer/CustomerScopeRateCreate.vue